import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { CalendarEventResponseData } from '@webparts/components/webparts/NewStone/Calendar/types'
import api from '@home/api'
import { mapGetters } from 'vuex';

import * as types from '@webparts/store/types'
import * as typesAccount from '@account/store/types'

import { IEDate } from "@appbase/util";

export enum GoTo {
    mail = "mail",
    workflowWaiting = "workflowWaiting",
    workflowProcessing = "workflowProcessing",
    eHR = "ehr",
    ifas = "ifas"
}


@Component({
    computed: {
        ...mapGetters({
            current: typesAccount.CURRENT,
            unreadMailCount: types.WEBPART_UNREADMAIL_COUNT_DATA
        })
    }
})
export default class MyCountWebpart extends Vue {
    @Prop({ type: Boolean, default: false }) isMailUser!: boolean;

    current!: account.TCurrent;
    unreadMailCount!: number;

    workflowWaitingMenuId: number = 0;
    workflowProcessingMenuId: number = 0;

    counts: home.homeWebpartCount = {
        workflowCount: {
            waiting: 0,
            processing: 0
        },
        eHRCount: {
            waiting: 0,
            processing: 0
        },
        ifasCount: {
            waiting: 0,
            ifasWaiting: 0
        },
    }

    get user() {
        return this.current.user;
    }

    mounted() {
        let endDate = IEDate(new Date());
        let startDate = IEDate(endDate);
        startDate.setFullYear(startDate.getFullYear() - 1);

        this.workflowWaitingMenuId = Number(this.getAppConfig('WorkflowMainMenuId'));
        this.workflowProcessingMenuId = Number(this.getAppConfig('WorkflowMainProcessingMenuId'));

        var promiseArr: Promise<any>[] = [];

        promiseArr.push(api.home.getDocumentBoxItemList({
            menuId: this.workflowWaitingMenuId,
            personCode: this.user.personCode,
            deptCode: this.user.deptCode,
            startDate: IEDate(startDate),
            endDate: IEDate(endDate),
            itemsPerPage: 99,
            page: 1,
            searchText: "",
            searchValue: 0,
            applicationId: 0,
        }));
        promiseArr.push(api.home.getDocumentBoxItemList({
            menuId: this.workflowProcessingMenuId,
            personCode: this.user.personCode,
            deptCode: this.user.deptCode,
            startDate: IEDate(startDate),
            endDate: IEDate(endDate),
            itemsPerPage: 99,
            page: 1,
            searchText: "",
            searchValue: 0,
            applicationId: 0,
        }));
        promiseArr.push(api.kyobobook.getEHRCount());
        promiseArr.push(api.kyobobook.getIFASCount());

        return Promise.all(promiseArr).then((res) => {
            this.counts.workflowCount.waiting = res[0].totalCount;
            this.counts.workflowCount.processing = res[1].totalCount;
            this.counts.eHRCount = res[2];
            this.counts.ifasCount = res[3];
        });
    }

    async onClickedIcon(value: GoTo) {
        let routePath = ""
        if (value == GoTo.mail) {
            window.open('https://outlook.office.com/mail', '_blank');
        } else if (value == GoTo.workflowWaiting) {
            routePath = `/workflow/page/documentbox?MENUID=${this.workflowWaitingMenuId}&SYSID=1`;
        } else if (value == GoTo.workflowProcessing) {
            routePath = `/workflow/page/documentbox?MENUID=${this.workflowProcessingMenuId}&SYSID=1`;
        }else if (value == GoTo.eHR) {
            window.open('https://ehr.kyobobook.co.kr/sso/index.jsp', '_blank');
        } else if (value == GoTo.ifas) {
            window.open('https://ifas.kyobobook.co.kr/sso/index.jsp', '_blank');
        }

        //this.$router 에서 window.open 으로 변경
        //window.open -> window.location.href 로 변경
        window.location.href = routePath
        // window.open(routePath)
    }
}
